import BillingsOrderRailyTaxiCreateRequest, {
  BillingsOrderRailyTaxiCreateRequestBillingNode,
  BillingsOrderRailyTaxiCreateRequestBonusType,
  BillingsOrderRailyTaxiCreateRequestPenaltyType,
} from "../../../../../api/raily/billings/order/raily-taxi/create/billings-order-raily-taxi-create.request";
import BillingsOrderRailyTaxiCreateParams, {
  BillingsOrderRailyTaxiCreateParamsBillingNode,
  BillingsOrderRailyTaxiCreateParamsBonusType,
  BillingsOrderRailyTaxiCreateParamsPenaltyType,
} from "./billings-order-raily-taxi-create-params";

const createBillingNode = (
  node: BillingsOrderRailyTaxiCreateParamsBillingNode,
): BillingsOrderRailyTaxiCreateRequestBillingNode => {
  return {
    allowCharge: node.allowCharge,
    description: node.description,
    distance: node.distance,
    editableCoordinates: node.editableCoordinates,
    haltingTime: node.haltingTime,
    highwayCharge: node.highwayCharge,
    id: node.uuid,
    lat: node.lat,
    lon: node.lon,
    nodeId: node.nodeUuid,
    plannedDistance: node.plannedDistance,
    checkoutDate: node.checkoutDate,
    checkoutEventId: node.checkoutEventUuid,
    orderId: node.orderUuid,
    plannedDate: node.plannedDate,
  };
};

const createBillingNodes = (
  nodes: BillingsOrderRailyTaxiCreateParamsBillingNode[],
): BillingsOrderRailyTaxiCreateRequestBillingNode[] => {
  return nodes.map(createBillingNode);
};

const createBonusType = (
  bonusType: BillingsOrderRailyTaxiCreateParamsBonusType | undefined,
): BillingsOrderRailyTaxiCreateRequestBonusType | undefined => {
  switch (bonusType) {
    case BillingsOrderRailyTaxiCreateParamsBonusType.DISTANCE_RATE_CHANGED:
      return BillingsOrderRailyTaxiCreateRequestBonusType.DISTANCE_RATE_CHANGED;
    case BillingsOrderRailyTaxiCreateParamsBonusType.HALTING_RATE_CHANGED:
      return BillingsOrderRailyTaxiCreateRequestBonusType.HALTING_RATE_CHANGED;
    case BillingsOrderRailyTaxiCreateParamsBonusType.OTHER:
      return BillingsOrderRailyTaxiCreateRequestBonusType.OTHER;
    case BillingsOrderRailyTaxiCreateParamsBonusType.SHORT_ROUTE:
      return BillingsOrderRailyTaxiCreateRequestBonusType.SHORT_ROUTE;
    default:
      return undefined;
  }
};

const createPenaltyType = (
  penaltyType: BillingsOrderRailyTaxiCreateParamsPenaltyType | undefined,
): BillingsOrderRailyTaxiCreateRequestPenaltyType | undefined => {
  switch (penaltyType) {
    case BillingsOrderRailyTaxiCreateParamsPenaltyType.BEING_LATE:
      return BillingsOrderRailyTaxiCreateRequestPenaltyType.BEING_LATE;
    case BillingsOrderRailyTaxiCreateParamsPenaltyType.GUIDELINE_IGNORED:
      return BillingsOrderRailyTaxiCreateRequestPenaltyType.GUIDELINE_IGNORED;
    case BillingsOrderRailyTaxiCreateParamsPenaltyType.HIGHWAY_NOT_ALLOWED:
      return BillingsOrderRailyTaxiCreateRequestPenaltyType.HIGHWAY_NOT_ALLOWED;
    case BillingsOrderRailyTaxiCreateParamsPenaltyType.INCOMPATIBLE_CAR:
      return BillingsOrderRailyTaxiCreateRequestPenaltyType.INCOMPATIBLE_CAR;
    case BillingsOrderRailyTaxiCreateParamsPenaltyType.OPTIMIZATION_REFUSED:
      return BillingsOrderRailyTaxiCreateRequestPenaltyType.OPTIMIZATION_REFUSED;
    case BillingsOrderRailyTaxiCreateParamsPenaltyType.OTHER:
      return BillingsOrderRailyTaxiCreateRequestPenaltyType.OTHER;
    case BillingsOrderRailyTaxiCreateParamsPenaltyType.SUBOPTIMAL_RIDE:
      return BillingsOrderRailyTaxiCreateRequestPenaltyType.SUBOPTIMAL_RIDE;
    default:
      return undefined;
  }
};

const createRequest = (
  params: BillingsOrderRailyTaxiCreateParams,
): BillingsOrderRailyTaxiCreateRequest => {
  return {
    orderUuid: params.orderUuid,
    billingNodes: createBillingNodes(params.billingNodes),
    bonus: params.bonus,
    penalty: params.penalty,
    bonusType: createBonusType(params.bonusType),
    penaltyType: createPenaltyType(params.penaltyType),
  };
};

const billingsOrderRailyTaxiCreateParamsFactory = {
  createRequest,
};

export default billingsOrderRailyTaxiCreateParamsFactory;
